// extracted by mini-css-extract-plugin
module.exports = {"discover":"button_discover__13mCM","button__wrapper":"button_button__wrapper__3zkCz"};